import { getType, } from "@inkandswitch/patchwork-filesystem";
import { getRegistry } from "./registry/index.js";
export function getSupportedToolsForType(type) {
    const plugins = getRegistry("patchwork:tool").filter((desc) => {
        return (desc.supportedDatatypes?.includes(type) ||
            desc.supportedDatatypes?.includes("*"));
    });
    return plugins;
}
export function getSupportedTools(doc) {
    const type = getType(doc);
    if (!type)
        return [];
    return getSupportedToolsForType(type);
}
export function getFallbackTool(doc) {
    const type = getType(doc);
    const plugins = getSupportedTools(doc);
    return sortPlugins(plugins, "supportedDatatypes", type, "id")?.filter((tool) => !tool.unlisted)?.[0];
}
const sortPlugins = (plugins, matchField, matchValue, sortField) => {
    return [...plugins].sort((a, b) => {
        const aValue = a[matchField];
        const bValue = b[matchField];
        // Convert string values to arrays for consistent comparison
        const aArray = Array.isArray(aValue)
            ? aValue
            : [aValue];
        const bArray = Array.isArray(bValue)
            ? bValue
            : [bValue];
        const aHasWildcard = aArray.includes("*");
        const bHasWildcard = bArray.includes("*");
        const aHasMatch = aArray.includes(matchValue);
        const bHasMatch = bArray.includes(matchValue);
        // Specific matches come first
        if (aHasMatch && !bHasMatch)
            return -1;
        if (!aHasMatch && bHasMatch)
            return 1;
        // Then wildcard matches come last
        if (aHasWildcard && !bHasWildcard)
            return 1;
        if (!aHasWildcard && bHasWildcard)
            return -1;
        // If both are wildcards or both are specific matches, sort by the optional sort field
        if (sortField) {
            const aSort = a[sortField];
            const bSort = b[sortField];
            if (typeof aSort === "string" && typeof bSort === "string") {
                return aSort.localeCompare(bSort);
            }
        }
        return 0;
    });
};
